import { axiosInstance } from "@/lib/axios-instance";

export interface WebSearchResult {
  company_name?: string;
  website_url?: string;
  description?: string;
  industry?: string;
  founded_year?: string;
  location?: string;
  linkedin_url?: string;
}

export interface LinkedInSearchResult {
  company_name?: string;
  linkedin_url?: string;
  description?: string;
  industry?: string;
  company_size?: string;
  headquarters?: string;
  founded_year?: string;
  website_url?: string;
}

export interface CompanySearchResponse {
  status: string;
  data: WebSearchResult | LinkedInSearchResult | unknown;
}

export const companySearchApi = {
  /**
   * Search for company information via web search
   */
  searchWeb: async (companyName: string): Promise<CompanySearchResponse> => {
    const response = await axiosInstance.post<CompanySearchResponse>(
      "/company-search/web",
      { company_name: companyName }
    );
    return response.data;
  },

  /**
   * Search for company information via LinkedIn
   */
  searchLinkedIn: async (
    companyName: string,
    websiteUrl?: string
  ): Promise<CompanySearchResponse> => {
    const response = await axiosInstance.post<CompanySearchResponse>(
      "/company-search/linkedin",
      {
        company_name: companyName,
        website_url: websiteUrl || "",
      }
    );
    return response.data;
  },
};
